export default {
  pageTitle: 'Corrosion Science and Prevention Seminar',
  metaDescription: 'Invite PT Tokki Engineering and Fabrication (TEF) to hold the Corrosion Science and Prevention seminar at your company.',
  hero: {
    eyebrow: 'TOKKI (TEF) CORROSION SEMINAR',
    titleGreen: 'Corrosion Science',
    titleBlack: 'and Prevention',
    subtitleLine1: 'Practical Knowledge. Real Solutions.',
    subtitleLine2: 'A Safer and More Reliable Tomorrow.',
    description: "Improve the safety, reliability, and service life of your industrial equipment with insights from TOKKI (TEF)'s experience in engineering, material selection, welding, repair, and maintenance.",
    registerBtn: 'Register for Seminar',
    learnMoreBtn: 'Learn More',
    badgeSmall: 'Your Corrosion Doctor',
    badgeTagline1: 'Reliable Equipment',
    badgeTagline2: 'Stronger Industry',
    badgeTagline3: 'A Brighter Indonesia',
  },
  about: {
    eyebrow: 'ABOUT THE SEMINAR',
    heading: 'What You Will Learn',
    intro: "In this seminar, we explain key topics in clear and practical terms, based on TOKKI (TEF)'s experience in the field.",
    topics: {
      t1: { title: 'How and why corrosion occurs', desc: '' },
      t2: { title: 'Characteristics and corrosion behavior of different metals', desc: '' },
      t3: { title: 'Types of corrosion', desc: '(general corrosion, pitting corrosion, crevice corrosion, and stress corrosion cracking)' },
      t4: { title: 'Material selection', desc: 'based on fluid, temperature, pressure, and concentration' },
      t5: { title: 'Methods for corrosion prevention, inspection, monitoring, and maintenance', desc: '' },
      t6: { title: 'Actual cases and solutions', desc: 'involving heat exchangers, pressure vessels, piping, and other equipment' },
    },
    customizationNote: 'The seminar content can be customized according to your industry, equipment, operating conditions, and specific corrosion concerns.',
  },
  locations: {
    eyebrow: 'SEMINAR LOCATIONS',
    heading: 'Seminar Locations',
    description: 'The seminar is available at either of the following locations:',
    clientSite: { title: "At the customer's factory or facility" },
    tefOffice: { title: 'At a TOKKI (TEF) factory' },
  },
  audience: {
    eyebrow: 'WHO SHOULD ATTEND?',
    heading: 'Who Should Attend?',
    roles: [
      'Plant Managers',
      'Maintenance & Equipment Personnel',
      'Engineers',
      'Inspection & QA/QC Personnel',
      'Production & Operation Teams',
      'Procurement Personnel',
      'Young Engineers',
    ],
  },
  process: {
    eyebrow: 'FROM REPAIRING TO PROTECTING',
    headingLine1: 'From Repairing After Failure',
    headingLine2: 'to Protecting Before Failure',
    description: 'Corrosion management is not only about repairing equipment after it has failed. It is important to understand corrosion risks correctly and take early action at every stage:',
    steps: ['Design', 'Material Selection', 'Fabrication', 'Welding', 'Inspection', 'Operation', 'Maintenance'],
  },
  commitment: {
    eyebrow: 'OUR COMMITMENT',
    heading: 'Our Commitment',
    description: "TOKKI (TEF) protects our customers' valuable industrial equipment by applying our practical manufacturing knowledge and extensive field experience.",
    tagline: 'Masa Depan <b>INDONESIA</b>,<br>Dengan Teknologi <b>INDONESIA</b>.',
    subtagline: 'The Future of Indonesia,<br>with Indonesian Technology!',
  },
  contact: {
    eyebrow: 'HAVE QUESTIONS?',
    heading: 'Have Questions?',
    description: 'For further information about the "Corrosion Science and Prevention" seminar, please contact the TOKKI (TEF) Business Development Team.',
    button: 'Contact Our Team',
    tagline: 'Together, we build a safer and more sustainable industry.',
  },
  form: {
    heading: 'Register for the Seminar',
    subheading: 'Fill in the form below and our team will contact you for further details',
    fullName: 'Full Name',
    fullNamePlaceholder: 'Enter your full name',
    companyName: 'Company Name',
    companyNamePlaceholder: 'Enter your company name',
    jobTitle: 'Job Title',
    jobTitlePlaceholder: 'Enter your job title',
    industry: 'Industry',
    industryPlaceholder: 'Select industry',
    industries: ['Oil & Gas', 'Petrochemical', 'Pharmaceutical', 'Fertilizer', 'Power Generation', 'Other'],
    email: 'Email',
    emailPlaceholder: 'Enter your email address',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceholder: 'Enter your phone number',
    preferredDate: 'Preferred Date',
    participants: 'Estimated Participants',
    participantsPlaceholder: 'Number of participants',
    location: 'Seminar Location',
    locationPlaceholder: 'Select location',
    locationClientSite: "At your company's site",
    locationTefOffice: 'At a TEF facility',
    message: 'Message / Specific Interest',
    messagePlaceholder: 'Let us know your specific interests or questions... (optional)',
    submit: 'Submit Registration',
    pleaseWait: 'Please Wait...',
    successMessage: 'Your seminar invitation has been submitted. Our team will contact you shortly.',
    errorMessage: 'Failed to submit the invitation. Please try again.',
    requiredNotice: 'All fields marked with * are required',
    confidentialNotice: 'Your information is kept confidential',
  },
};
